import React, { useState } from "react";
import logo from "../../assets/img/logoNewBright.png";
import { PORT } from "../../config";
import { notify } from "react-notify-toast";
import { API } from "../../API";

const ResetSendEmail = (props) => {
  const [email, setEmail] = useState("");
  const URL = PORT;

  const handleSendEmail = async (event) => {
    event.preventDefault();
    await API.requestPasswordReset({
      user: {
        email,
      }
    })
      .then((res) => {
        props.history.push("/login");
        notify.show("Check your email to reset your password.");
      })
      .catch((err) => {
        notify.show("User not found.");
      });
  };

  return (
    <div className="row">
      <div className="col-lg-6 auth-left">
        <div className="row auth-form mb-4 small-screen-reset-password-container login-form-container">
          <div className="col-12 col-sm-12">
            <div className="auth-text-top mb-4">
              <h1>Reset Password</h1>
              <hr />
              <small>
                Enter your email address and we'll send you instructions to
                reset your password.
              </small>
            </div>
            <form onSubmit={handleSendEmail}>
              <div className="form-group">
                <div className="input-icon">
                  <i className="mdi mdi-email" />
                  <input
                    type="email"
                    className="form-control rt-input"
                    id="email"
                    name="email"
                    placeholder="example@email.com"
                    onChange={(e) => setEmail(e.target.value)}
                    autoFocus
                    // pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    required
                  />
                </div>
              </div>
              <button className="btn btn-primary btn-block btn-c mt-5 mb-4">
                Reset Password
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="col-lg-6 auth-right d-lg-flex d-none bg-photoregister">
        <div className="bg-gradient" />

        <div className="logo-container">
          <img src={logo} alt="logo" className="logo logo_right" />
        </div>

        <div className="shape" />
      </div>
    </div>
  );
};

export default ResetSendEmail;
